import type { TeamEntitlementsResponse } from '@kangaroo/shared';

export function workspaceGuide(entitlements: TeamEntitlementsResponse | null | undefined) {
  // Feature-only member responses contain no usage counts or onboarding duties.
  if (!entitlements?.usage) {
    return null;
  }

  if (entitlements.requiresPaidPlan) {
    return {
      path: '/billing',
      action: 'Go to billing',
      message: 'Add a payment method or partner code to keep team features active.',
    };
  }

  if ((entitlements.usage.drivers ?? 0) <= 0) {
    return {
      path: '/drivers',
      action: 'Add drivers',
      message: 'Add your first driver so sessions and roster tools have someone to track.',
    };
  }

  if ((entitlements.usage.vehicles ?? 0) <= 0) {
    if (entitlements.planId === 'privateer') {
      return {
        path: '/karts',
        action: 'Add vehicle',
        message:
          'Finish setup by adding your kart or vehicle so maintenance, setup sheets, and sessions have equipment to track.',
      };
    }

    return {
      path: '/karts',
      action: 'Add vehicles',
      message:
        'Add your first kart or vehicle so sessions and maintenance can connect to equipment.',
    };
  }

  return null;
}

